/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Web_Scraping_Scope_Output5Inputs */

const en_svc_web_scraping_scope_output5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target feasibility report`)
};

const ar_svc_web_scraping_scope_output5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقرير جدوى الهدف`)
};

const bn_svc_web_scraping_scope_output5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টার্গেট ফিজিবিলিটি রিপোর্ট`)
};

const de_svc_web_scraping_scope_output5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel-Machbarkeitsbericht`)
};

const es_svc_web_scraping_scope_output5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe de viabilidad objetivo`)
};

const fr_svc_web_scraping_scope_output5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rapport de faisabilité cible`)
};

const pt_svc_web_scraping_scope_output5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relatório de viabilidade alvo`)
};

const zh_svc_web_scraping_scope_output5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标可行性报告`)
};

const tr_svc_web_scraping_scope_output5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hedef fizibilite raporu`)
};

const ru_svc_web_scraping_scope_output5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевой технико-экономический отчет`)
};

const pl_svc_web_scraping_scope_output5 = /** @type {(inputs: Svc_Web_Scraping_Scope_Output5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raport wykonalności celu`)
};

/**
* | output |
* | --- |
* | "Target feasibility report" |
*
* @param {Svc_Web_Scraping_Scope_Output5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_web_scraping_scope_output5 = /** @type {((inputs?: Svc_Web_Scraping_Scope_Output5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Web_Scraping_Scope_Output5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_web_scraping_scope_output5(inputs)
	if (locale === "bn") return bn_svc_web_scraping_scope_output5(inputs)
	if (locale === "de") return de_svc_web_scraping_scope_output5(inputs)
	if (locale === "es") return es_svc_web_scraping_scope_output5(inputs)
	if (locale === "fr") return fr_svc_web_scraping_scope_output5(inputs)
	if (locale === "pt") return pt_svc_web_scraping_scope_output5(inputs)
	if (locale === "zh") return zh_svc_web_scraping_scope_output5(inputs)
	if (locale === "tr") return tr_svc_web_scraping_scope_output5(inputs)
	if (locale === "ru") return ru_svc_web_scraping_scope_output5(inputs)
	if (locale === "pl") return pl_svc_web_scraping_scope_output5(inputs)
	return en_svc_web_scraping_scope_output5(inputs)
});
export { svc_web_scraping_scope_output5 as "svc_web-scraping_SCOPE_output" }